import { type TabItem, Tabs } from "@aurem/ui";
import { useNavigation } from "hooks/navigate";
import { useEmployeeFatcaForm } from "pages/employee/Settings/TaxInformation/hooks";
import { useFeature } from "providers/FeaturesProvider";
import { useI18n } from "providers/I18nProvider";
import { useCallback, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { PageLayout } from "../PageLayout";

export const LayoutSettings = () => {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const navigate = useNavigation();
  const isBeneficiariesEnabled = useFeature("beneficiaries_feature");
  const { formTemplate } = useEmployeeFatcaForm();

  const tabItems = useMemo(() => {
    const paths: TabItem[] = [
      {
        id: "account-details",
        text: t("apps.employee.pages.settings.navigation.accountDetails"),
      },
      {
        id: "employment-details",
        text: t("apps.employee.pages.settings.navigation.employmentDetails"),
      },
      {
        id: "bank-details",
        text: t("apps.employee.pages.settings.navigation.bankDetails"),
      },
      ...(formTemplate
        ? [
            {
              id: "tax-information",
              text: t("apps.employee.pages.settings.navigation.taxInformation"),
            },
          ]
        : []),
      {
        id: "security",
        text: t("apps.employee.pages.settings.navigation.security"),
      },
      {
        id: "documents",
        text: t("apps.employee.pages.settings.navigation.documents"),
      },
      ...(isBeneficiariesEnabled
        ? [
            {
              id: "beneficiaries",
              text: t("apps.employee.pages.settings.navigation.beneficiaries"),
            },
          ]
        : []),
    ];

    return paths;
  }, [t, isBeneficiariesEnabled, formTemplate]);

  const activeItem =
    tabItems.find((item) => pathname.endsWith(item.id))?.id || tabItems[0].id;

  const onTabChange = useCallback(
    (id: string) => {
      void navigate(`/settings/${id}`, { replace: true });
    },
    [navigate],
  );

  return (
    <PageLayout className="gap-8">
      <Tabs items={tabItems} activeItem={activeItem} onChange={onTabChange} />
      <Outlet />
    </PageLayout>
  );
};
